import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "relative",
  style: {
    "width": "100%",
    "height": "700px"
  }
};
const _hoisted_2 = {
  class: "absolute top-30px right-30px"
};
const _hoisted_3 = {
  class: "p-20px"
};
const _hoisted_4 = {
  class: "mt-20px bg-#f8f9fa"
};
const _hoisted_5 = {
  class: "p-20px"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 2,
  class: "result-content"
};
const _hoisted_9 = {
  key: 3
};
import Tinyflow from '@/components/Tinyflow/Tinyflow.vue';
import * as WorkflowApi from '@/api/ai/workflow';
// TODO @lesan：要不使用 ICon 哪个组件哈
import { Delete } from '@element-plus/icons-vue';
import { inject, ref, watch } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'WorkflowDesign',
  props: {
    provider: {}
  },
  setup(__props, {
    expose: __expose
  }) {
    const tinyflowRef = ref();
    const workflowData = inject('workflowData');
    const showTestDrawer = ref(false);
    const params4Test = ref([]);
    const paramsOfStartNode = ref({});
    const testResult = ref(null);
    const loading = ref(false);
    const error = ref(null);
    /** 展示工作流测试抽屉 */
    const testWorkflowModel = () => {
      showTestDrawer.value = !showTestDrawer.value;
    };
    /** 运行流程 */
    const goRun = async () => {
      try {
        const val = tinyflowRef.value.getData();
        loading.value = true;
        error.value = null;
        testResult.value = null;
        /// 查找start节点
        const startNode = getStartNode();
        // 获取参数定义
        const parameters = startNode.data?.parameters || [];
        const paramDefinitions = {};
        parameters.forEach(param => {
          paramDefinitions[param.name] = param.dataType;
        });
        // 参数类型转换
        const convertedParams = {};
        for (const {
          key,
          value
        } of params4Test.value) {
          const paramKey = key.trim();
          if (!paramKey) continue;
          let dataType = paramDefinitions[paramKey];
          if (!dataType) {
            dataType = 'String';
          }
          try {
            convertedParams[paramKey] = convertParamValue(value, dataType);
          } catch (e) {
            throw new Error(`参数 ${paramKey} 转换失败: ${e.message}`);
          }
        }
        const data = {
          graph: JSON.stringify(val),
          params: convertedParams
        };
        const response = await WorkflowApi.testWorkflow(data);
        testResult.value = response;
      } catch (err) {
        error.value = err.response?.data?.message || '运行失败，请检查参数和网络连接';
      } finally {
        loading.value = false;
      }
    };
    /** 监听测试抽屉的开启，获取开始节点参数列表 */
    watch(showTestDrawer, value => {
      if (!value) return;
      /// 查找start节点
      const startNode = getStartNode();
      // 获取参数定义
      const parameters = startNode.data?.parameters || [];
      const paramDefinitions = {};
      // 加入参数选项方便用户添加非必须参数
      parameters.forEach(param => {
        paramDefinitions[param.name] = param;
      });
      function mergeIfRequiredButNotSet(target) {
        let needPushList = [];
        for (let key in paramDefinitions) {
          let param = paramDefinitions[key];
          if (param.required) {
            let item = target.find(item => item.key === key);
            if (!item) {
              needPushList.push({
                key: param.name,
                value: param.defaultValue || ''
              });
            }
          }
        }
        target.push(...needPushList);
      }
      // 自动装载需必填的参数
      mergeIfRequiredButNotSet(params4Test.value);
      paramsOfStartNode.value = paramDefinitions;
    });
    /** 获取开始节点 */
    const getStartNode = () => {
      const val = tinyflowRef.value.getData();
      const startNode = val.nodes.find(node => node.type === 'startNode');
      if (!startNode) {
        throw new Error('流程缺少开始节点');
      }
      return startNode;
    };
    /** 添加参数项 */
    const addParam = () => {
      params4Test.value.push({
        key: '',
        value: ''
      });
    };
    /** 删除参数项 */
    const removeParam = index => {
      params4Test.value.splice(index, 1);
    };
    /** 类型转换函数 */
    const convertParamValue = (value, dataType) => {
      if (value === '') return null; // 空值处理
      switch (dataType) {
        case 'String':
          return String(value);
        case 'Number':
          const num = Number(value);
          if (isNaN(num)) throw new Error('非数字格式');
          return num;
        case 'Boolean':
          if (value.toLowerCase() === 'true') return true;
          if (value.toLowerCase() === 'false') return false;
          throw new Error('必须为 true/false');
        case 'Object':
        case 'Array':
          try {
            return JSON.parse(value);
          } catch (e) {
            throw new Error(`JSON格式错误: ${e.message}`);
          }
        default:
          throw new Error(`不支持的类型: ${dataType}`);
      }
    };
    /** 表单校验 */
    const validate = async () => {
      try {
        // 获取最新的流程数据
        if (!workflowData.value) {
          throw new Error('请设计流程');
        }
        workflowData.value = tinyflowRef.value.getData();
        return true;
      } catch (error) {
        throw error;
      }
    };
    __expose({
      validate
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(workflowData) ? (_openBlock(), _createBlock(Tinyflow, {
        key: 0,
        ref_key: "tinyflowRef",
        ref: tinyflowRef,
        className: 'custom-class',
        style: {
          width: '100%',
          height: '100%'
        },
        data: _unref(workflowData),
        provider: _ctx.provider
      }, null, 8, ["data", "provider"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: testWorkflowModel,
        type: "primary"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 测试 ")])),
        _: 1
      })), [[_directive_hasPermi, ['ai:workflow:test']]])]), _createVNode(_component_el_drawer, {
        modelValue: showTestDrawer.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showTestDrawer.value = $event),
        title: "工作流测试",
        modal: false
      }, {
        default: _withCtx(() => [_createElementVNode("fieldset", null, [_cache[3] || (_cache[3] = _createElementVNode("legend", {
          class: "ml-15px"
        }, [_createElementVNode("h3", null, "运行参数配置")], -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(params4Test.value, (param, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "flex justify-around mb-10px",
            key: index
          }, [_createVNode(_component_el_select, {
            class: "w-200px!",
            modelValue: param.key,
            "onUpdate:modelValue": $event => param.key = $event,
            placeholder: "参数名"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paramsOfStartNode.value, (value, key) => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: key,
                label: value?.description || key,
                value: key,
                disabled: !!value?.disabled
              }, null, 8, ["label", "value", "disabled"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_input, {
            class: "w-200px!",
            modelValue: param.value,
            "onUpdate:modelValue": $event => param.value = $event,
            placeholder: "参数值"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createVNode(_component_el_button, {
            type: "danger",
            plain: "",
            icon: _unref(Delete),
            circle: "",
            onClick: $event => removeParam(index)
          }, null, 8, ["icon", "onClick"])]);
        }), 128)), _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: addParam
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("添加参数")])),
          _: 1
        })])]), _createElementVNode("fieldset", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("legend", {
          class: "ml-15px"
        }, [_createElementVNode("h3", null, "运行结果")], -1)), _createElementVNode("div", _hoisted_5, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_text, {
          type: "primary"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("执行中...")])),
          _: 1
        })])) : error.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_text, {
          type: "danger"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(error.value), 1)]),
          _: 1
        })])) : testResult.value ? (_openBlock(), _createElementBlock("pre", _hoisted_8, _toDisplayString(JSON.stringify(testResult.value, null, 2)) + "\n          ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_el_text, {
          type: "info"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("点击运行查看结果")])),
          _: 1
        })]))])]), _createVNode(_component_el_button, {
          class: "mt-20px w-100%",
          size: "large",
          type: "success",
          onClick: goRun
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" 运行流程 ")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});